import React, { useEffect, useState } from 'react';

import Cookies from 'universal-cookie';

import Image from '../../../components/basic/Image';
import SectionBuilder from '../../SectionBuilder';

const cookies = new Cookies();

const checkScreenWidth = () => {
  return window.innerWidth >= 1024;
};

const BlogEmailPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasSignedUp, setHasSignedUp] = useState(false);
  const isCookieAU = cookies.get('NEXT_LOCALE') === 'en-AU';

  useEffect(() => {
    if (!checkScreenWidth()) {
      return;
    }

    const hasDismissed = cookies.get('blogEmailPopupDismissed');
    const hasSignedUpCookie = cookies.get('blogEmailPopupSignedUp');
    if (!hasDismissed && !hasSignedUpCookie) {
      const timer = setTimeout(() => {
        setIsVisible(true);
        document.body.style.overflow = 'hidden';

        window.dataLayer.push({
          event: 'modal_loaded',
          modal_name: 'Blog Email Popup',
        });
      }, 20_000);

      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (!checkScreenWidth()) {
        setIsVisible(false);
        document.body.style.overflow = '';
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    document.body.style.overflow = '';
    cookies.set('blogEmailPopupDismissed', 'true', { path: '/blog' });

    window.dataLayer.push({
      event: 'modal_closed',
      modal_name: 'Blog Email Popup',
    });
  };

  const handleSignUp = () => {
    if (!isCookieAU) {
      setHasSignedUp(true);
      setIsVisible(true);
    }

    document.body.style.overflow = '';

    window.dataLayer.push({
      event: 'subscribe_clicked',
      modal_name: 'Blog Email Popup',
    });
    cookies.set('blogEmailPopupSignedUp', 'true', {
      maxAge: 365 * 24 * 60 * 60,
      path: '/',
    });

    if (isCookieAU) {
      setIsVisible(false);
      window.open('/blog-thank-you', '_blank');
    }
  };

  const popUpContent = (isAU) => {
    if (isAU) {
      return (
        <>
          <h4 className="mb-8 text-plum-800">2025 Australian Payroll & Hiring Intelligence Pack</h4>
          <p className="is-style-p2 text-plum-800 opacity-70 mb-10">
            Get instant access to:
          </p>
          <div className="wrapper flex gap-8 items-start sm:items-center justify-left pb-12 ">
            <div className="imagex w-24 h-24 shrink-0 flex items-center ">
              <img loading="lazy" src="https://rippling2.imgix.net/check-circle-5.svg" />
            </div>
            <p className="text-plum-800 is-style-p2 opacity-70 ">Compliance trends reshaping Australian payroll</p>
          </div>
          <div className="wrapper flex gap-8 items-start sm:items-center justify-left pb-12 ">
            <div className="imagex w-24 h-24 shrink-0 flex items-center ">
              <img loading="lazy" src="https://rippling2.imgix.net/check-circle-5.svg" />
            </div>
            <p className="text-plum-800 is-style-p2 opacity-70 ">Industry benchmarks and salary insights</p>
          </div>
          <div className="wrapper flex gap-8 items-start sm:items-center justify-left pb-12 ">
            <div className="imagex w-24 h-24 shrink-0 flex items-center ">
              <img loading="lazy" src="https://rippling2.imgix.net/check-circle-5.svg" />
            </div>
            <p className="text-plum-800 is-style-p2 opacity-70 ">Strategic recommendations for FY25</p>
          </div>
          <div className="wrapper flex gap-8 items-start sm:items-center justify-left pb-12 ">
            <div className="imagex w-24 h-24 shrink-0 flex items-center ">
              <img loading="lazy" src="https://rippling2.imgix.net/check-circle-5.svg" />
            </div>
            <p className="text-plum-800 is-style-p2 opacity-70 ">Productivity forecasts for FY25</p>
          </div>
          <div className="wrapper flex gap-8 items-start sm:items-center justify-left pb-12 mb-12">
            <div className="imagex w-24 h-24 shrink-0 flex items-center ">
              <img loading="lazy" src="https://rippling2.imgix.net/check-circle-5.svg" />
            </div>
            <p className="text-plum-800 is-style-p2 opacity-70 ">Expert analysis of hiring trends</p>
          </div>
          <SectionBuilder
            blocks={[
              {
                attributes: {
                  campaign_name: '',
                  className:
                  'blog-popup-form-container -bg-white basic-hero-input-form w-100% flex max-w-[360px] flex-col rounded-4',
                  customOnSuccess: handleSignUp,
                  data: {},
                  formType: 'content',
                  hiddenInputs: {
                    Form_Type__c: 'Form_Type__c: Content',
                    Last_Lead_Origin__c:
                    '701Ud00000HhaeMIAR',
                  },
                  isSimpleSubmit: false,
                  turnOffThankYouPageRedirect: true,
                },
                innerBlocks: [
                  {
                    attributes: {
                      className: 'w-100%',
                      data: {},
                      innerClassName: 'rounded-4 overflow-hidden',
                      label: 'Email address',
                      name: 'user_email',
                      onClick: () => {
                        window.dataLayer.push({
                          event: 'email_form_clicked',
                          modal_name: 'Blog Email Popup',
                        });
                      },
                      placeholder: 'Enter your email',
                      showError: false,
                      type: 'email',
                    },
                    name: 'field2',
                  },
                  {
                    attributes: {
                      className: 'flex rounded-4 w-100%',
                      data: {},
                      value: 'Unlock your first report',
                    },
                    name: 'submit',
                  },
                ],
                name: 'form-2',
              },
            ]}
          />
          <p className="leading-14 mt-12 text-10 text-plum-800 mt-12 max-w-[360px]">
            <span className="opacity-70">By clicking &ldquo;Unlock your first report,&rdquo; you agree to the use of your data in
              accordance with Rippling&rsquo;s&nbsp;
            </span>
            <a
              className="border-b-1
            hover:text-secondary-blue transition duration-300 whitespace-nowrap ease-in-out hover:border-secondary-blue"
              href="https://app.rippling.com/legal/privacy"
              rel="noreferrer"
              target="_blank"
            >
              Privacy Notice
            </a>
            <span className="opacity-70">, including for marketing purposes.</span>
          </p>
        </>
      );
    } else {
      return (
        <>
          <h4 className="mb-8 text-plum-800">Enjoying this article?</h4>
          <p className="is-style-p2 text-plum-800 opacity-70 mb-24">
            Sign up for our email list for the latest resources delivered
            straight to your inbox.
          </p>
          <SectionBuilder
            blocks={[
              {
                attributes: {
                  campaign_name: '',
                  className:
                      'blog-popup-form-container -bg-white basic-hero-input-form w-100% flex flex-col rounded-4',
                  customOnSuccess: handleSignUp,
                  data: {},
                  formType: 'content',
                  hiddenInputs: {
                    Form_Type__c: 'Content',
                    Last_Lead_Origin__c:
                        'Content_CORE_DEFAULT_701Ud00000CuevBIAR',
                  },
                  isSimpleSubmit: false,
                  turnOffThankYouPageRedirect: true,
                },
                innerBlocks: [
                  {
                    attributes: {
                      className: 'w-100%',
                      data: {},
                      innerClassName: 'rounded-4 overflow-hidden',
                      label: 'Email address',
                      name: 'user_email',
                      onClick: () => {
                        window.dataLayer.push({
                          event: 'email_form_clicked',
                          modal_name: 'Blog Email Popup',
                        });
                      },
                      placeholder: 'Enter your email',
                      showError: false,
                      type: 'email',
                    },
                    name: 'field2',
                  },
                  {
                    attributes: {
                      className: 'flex rounded-4 w-100%',
                      data: {},
                      value: 'Subscribe',
                    },
                    name: 'submit',
                  },
                ],
                name: 'form-2',
              },
            ]}
          />
          <p className="leading-14 mt-12 text-10 text-plum-800 mt-12">
            <span className="opacity-70">By clicking “Subscribe,” you agree to the use of your data in
              accordance with Rippling&rsquo;s&nbsp;
            </span>
            <a
              className="border-b-1
                hover:text-secondary-blue transition duration-300 whitespace-nowrap ease-in-out hover:border-secondary-blue"
              href="https://app.rippling.com/legal/privacy"
              rel="noreferrer"
              target="_blank"
            >
              Privacy Notice
            </a>
            <span className="opacity-70">, including for marketing purposes.</span>
          </p>
        </>
      );
    }
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  if (!isVisible) {
    return null;
  }

  const mediaURL = isCookieAU ? 'https://rippling2.imgix.net/en-AU-newsletter-signup.png' : 'https://rippling2.imgix.net/blog-newsletter-signup.png';
  const widthClass = isCookieAU ? 'max-w-[1128px]' : 'max-w-950';

  return (
    <div className="hidden md:flex fixed inset-0 items-center justify-center bg-modal-black bg-opacity-50 z-6000">
      <div className={`overflow-hidden rounded-12 shadow-lg bg-white relative flex items-center justify-center w-100% p-4 ${widthClass}`}>
        <div className="imagex flex items-center justify-center max-w-550 w-100% rounded-8 overflow-hidden">
          <Image
            attributes={{
              mediaURL: mediaURL,
              nonResponsive: true,
            }}
          />
        </div>
        {/* Modal Content */}
        <div className="flex flex-col items-start justify-center p-48">
          {hasSignedUp ? (
            <>
              <h4 className="mb-8 plum-800">Thank you for subscribing!</h4>
              <p className="is-style-p2 text-plum-800 opacity-70 mb-24">
                Stay tuned—more exclusive tips and insights are heading your way
                soon.
              </p>
              <div className="bg-yellow w-100% rounded-4">
                <a
                  className="btn is-style-p2 font-medium py-16 w-100%"
                  href="/tour-video"
                  onClick={() => {
                    window.dataLayer.push({
                      event: 'watch_tour_video_clicked',
                      modal_name: 'Blog Email Popup',
                    });
                  }}
                >
                  Watch tour video
                </a>
              </div>
            </>
          ) :
            popUpContent(isCookieAU)
          }
        </div>
        {/* Close Button */}
        <button
          aria-label="Close Modal"
          className="absolute top-16 right-16 bg-transparent cursor-pointer"
          onClick={handleDismiss}
        >
          <img
            alt="Close"
            className="w-16 h-16"
            src="https://rippling2.imgix.net/Close-1.svg"
          />
        </button>
      </div>
    </div>

  );
};

export default BlogEmailPopup;
